module.exports = __webpack_public_path__ + "img/maestro.f18bdec6.svg";